import { Directive, Input, TemplateRef, OnDestroy, HostListener, ViewContainerRef, inject } from '@angular/core';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';

@Directive({
    selector: '[tooltipTrigger]',
    standalone: false
})
export class CstCardTooltipDirective implements OnDestroy {
    private overlay = inject(Overlay);
    private vcr = inject(ViewContainerRef);

    @Input('tooltipTrigger') tooltipTemplate: TemplateRef<any>;

    private overlayRef: OverlayRef | null = null;
    private openTimeout: any;
    private closeTimeout: any;

    @HostListener('mouseover', ['$event'])
    onMouseOver(event: MouseEvent) {
        const target = (event.target as HTMLElement).closest('[tooltip]');

        if (!target || this.overlayRef || this.openTimeout) return;

        clearTimeout(this.closeTimeout);
        this.closeTimeout = null;

        this.openTimeout = setTimeout(() => {
            if (this.tooltipTemplate) {
                this.attachTooltip(target as HTMLElement);
            }
        }, 150);
    }

    @HostListener('mouseleave')
    onMouseLeave() {
        this.startCloseTimer();
    }

    private attachTooltip(target: HTMLElement) {
        const strategy = this.overlay.position()
            .flexibleConnectedTo(target)
            .withViewportMargin(16)
            .withPush(true)
            .withPositions([
                { originX: 'center', originY: 'bottom', overlayX: 'center', overlayY: 'top', offsetY: 8 },
                { originX: 'center', originY: 'top', overlayX: 'center', overlayY: 'bottom', offsetY: -8 }
            ]);

        this.overlayRef = this.overlay.create({
            positionStrategy: strategy,
            scrollStrategy: this.overlay.scrollStrategies.close(),
            panelClass: 'cst-tooltip-pane'
        });

        const portal = new TemplatePortal(this.tooltipTemplate, this.vcr);
        this.overlayRef.attach(portal);
    }

    private startCloseTimer() {
        clearTimeout(this.openTimeout);
        this.openTimeout = null;

        if (!this.closeTimeout) {
            this.closeTimeout = setTimeout(() => {
                this.detachTooltip();
            }, 100);
        }
    }

    private detachTooltip() {
        if (this.overlayRef) {
            this.overlayRef.dispose();
            this.overlayRef = null;
        }
        this.closeTimeout = null;
    }

    ngOnDestroy() {
        this.detachTooltip();
    }
}